module.exports = "internal-link-arrow"